import React from "react"
import PropTypes from "prop-types"

const ProcessingOverlay = (props) => {
  const processing = props.processing;
  return(
    <div className={`${ processing ? '' : 'hidden' } flex w-full h-full fixed block top-0 left-0 bg-gray-600 opacity-75 z-50`}>
      <div className="m-auto">
        <h1 className="animate-pulse text-2xl md:text-4xl font-black">Processing Your Payment</h1>
      </div>
    </div>
  )
}

ProcessingOverlay.propTypes = {
  processing: PropTypes.bool,
}

export default ProcessingOverlay
